import { useApplicationStore } from '@data';
import { Paragraph } from '@quickmd-llc/design-system';
import { calculateCostBreakdown } from './utils';

export function Cost() {
  const activeRefill = useApplicationStore(
    ({ patient }) => patient.activeRefill,
  );
  const creditAmount =
    useApplicationStore(
      ({ patient }) => patient.patientProfile?.creditAmount,
    ) || 0;

  if (!activeRefill) {
    return null;
  }

  const { name, price } = activeRefill;

  const { formattedCreditAmount, formattedPrice, formattedTotalPrice } =
    calculateCostBreakdown(price, creditAmount);

  return (
    <>
      <Paragraph size="md" className="mb-2 font-semibold">
        Cost
      </Paragraph>

      <div className="flex justify-between">
        <Paragraph size="sm" className="font-semibold">
          {name}
        </Paragraph>
        <Paragraph size="sm" className="font-semibold">
          {formattedPrice}
        </Paragraph>
      </div>

      {creditAmount > 0 && (
        <div className="flex justify-between">
          <Paragraph size="sm" className="font-semibold">
            Account Credits
          </Paragraph>
          <Paragraph size="sm" className="font-semibold">
            -{formattedCreditAmount}
          </Paragraph>
        </div>
      )}

      <div className="my-2 h-[1px] w-full bg-shade-20" />

      <div className="flex justify-between">
        <Paragraph size="sm" className="font-semibold">
          Due Now
        </Paragraph>

        <Paragraph size="sm" className="font-semibold">
          {formattedTotalPrice}
        </Paragraph>
      </div>
    </>
  );
}
